// extracted by mini-css-extract-plugin
module.exports = {"editEventButton":"editEventButton-2QuGI","icon":"icon-2L8mC"};